import { api } from "@/lib/api";

const QKEY = "scan_offline_queue";
const CKEY = "scan_batch_cache";

export const readQueue = () => { try { return JSON.parse(localStorage.getItem(QKEY) || "[]"); } catch { return []; } };
const writeQueue = (q) => { localStorage.setItem(QKEY, JSON.stringify(q)); window.dispatchEvent(new Event("scan-queue-change")); };

export const enqueueScan = (payload) => {
  const entry = { ...payload, client_id: `scan-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, date: new Date().toISOString().slice(0, 10), queued_at: new Date().toISOString(), attempts: 0, last_error: "" };
  writeQueue([...readQueue(), entry]);
  return entry;
};
export const removeQueued = (client_id) => writeQueue(readQueue().filter((e) => e.client_id !== client_id));

export const isNetworkError = (e) => !e?.response;

let flushing = false;
export const flushQueue = async () => {
  if (flushing || !navigator.onLine) return { sent: 0, failed: 0 };
  flushing = true;
  let sent = 0, failed = 0;
  try {
    for (const entry of readQueue()) {
      try {
        await api.post("/transactions/scan-out", { items: entry.items, destination: entry.destination, note: entry.note, client_id: entry.client_id, date: entry.date });
        removeQueued(entry.client_id); sent++;
      } catch (e) {
        if (isNetworkError(e)) { failed++; break; }
        const q = readQueue().map((x) => (x.client_id === entry.client_id ? { ...x, attempts: (x.attempts || 0) + 1, last_error: e?.response?.data?.detail || "Ditolak server" } : x));
        writeQueue(q); failed++;
      }
    }
  } finally { flushing = false; }
  return { sent, failed };
};

export const cacheBatch = (b) => { try { const c = JSON.parse(localStorage.getItem(CKEY) || "{}"); c[b.batch_code.toUpperCase()] = { ...b, cached_at: new Date().toISOString() }; localStorage.setItem(CKEY, JSON.stringify(c)); } catch {} };
export const cachedBatch = (code) => { try { return JSON.parse(localStorage.getItem(CKEY) || "{}")[code.trim().toUpperCase()] || null; } catch { return null; } };
export const primeBatchCache = async () => { try { const r = await api.get("/inventory"); r.data.forEach(cacheBatch); } catch {} };
